<script>
import WebGLImageGlitch from '@/util/WebGLImageGlitch'

export default {
  name: 'GlitchedImage',

  props: {
    src: {
      type: String,
      required: true
    }
  },

  mounted () {
    this.applyFilter()
  },

  methods: {

    resetFilter () {
      if (this.filter) {
        this.filter.reset()
      }
    },

    applyFilter () {
      const img = new Image()
      img.src = this.src

      img.onload = () => {
        this.$refs.canvas.width = img.width
        this.$refs.canvas.height = img.height

        WebGLImageGlitch(this.$refs.canvas, img.src)
      }
    }

  }

}
</script>

<template>
  <!-- <div class="c-glitched-image">
    <div class="c-glitched-image-overlay" />
  </div> -->
  <canvas
    ref="canvas"
    class="c-glitched-image"
  />
</template>

<style lang="scss">

.c-glitched-image {
  @include relative;
  @include no-overflow;
}

// // Scanlines
// .c-glitched-image-overlay {
//   @include fill;
//   z-index: 2;
//   background-size: 100% 2px, 3px 100%;
//   background:
//     linear-gradient(
//       transparent($green) 50%,
//       translucent(darken($green, 10), 0.15) 50%
//     ),
//     linear-gradient(
//       90deg,
//       transparentize($red, 0.94),
//       transparentize($green, 0.98),
//       transparentize($blue, 0.94)
//     );
//   // box-shadow: inset 0 0 1rem 0.5rem $very-dark;
// }

// .c-glitched-image-canvas {
//   @include relative;
//   @include keep-full-center;
//   z-index: 1;
//   object-fit: cover;
// }

</style>
